import MockMan from "mockman-js";

const MockAPI = () => {
    return (
        <MockMan />
    );
}

export { MockAPI };